"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Analytics = /** @class */ (function () {
    function Analytics(providers) {
        this.providers = [];
        this.providers = providers.filter(function (provider) { return provider.isEnabled(); });
        this.providers.forEach(function (provider) { return provider.build(); });
        this.handleClicks = this.handleClicks.bind(this);
        this.findCategory = this.findCategory.bind(this);
    }
    Analytics.prototype.execute = function (callback) {
        this.providers.forEach(callback);
    };
    Analytics.prototype.handleClicks = function (eventClick) {
        var _a;
        var target = eventClick === null || eventClick === void 0 ? void 0 : eventClick.target;
        var action = (_a = target === null || target === void 0 ? void 0 : target.dataset) === null || _a === void 0 ? void 0 : _a.action;
        if (!action)
            return;
        var category = this.findCategory(target.parentElement);
        if (category) {
            this.execute(function (provider) { return provider.event(action, category); });
        }
    };
    Analytics.prototype.findCategory = function (parent) {
        if (!parent || !parent.dataset)
            return null;
        var category = parent.dataset.category;
        return category || this.findCategory(parent.parentElement);
    };
    Analytics.init = function (providers) {
        if (this.Instance)
            return;
        this.Instance = new Analytics(providers);
        document.addEventListener("click", this.Instance.handleClicks);
    };
    // TODO: Create the correspondent saga for handling the path change or the initial path event.
    Analytics.pageView = function (path) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) { return provider.pageView(path); });
    };
    Analytics.sendEvent = function (action, category) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) { return provider.event(action, category); });
    };
    Analytics.sendDimensionEvent = function (action, category, label, value) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) {
            return provider.dimensionEvent(action, category, label, value);
        });
    };
    Analytics.sendHTTPResponseEvent = function (name, info) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) { return provider.customEvent(name, info); });
    };
    Analytics.sendTrace = function (message) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) { return provider.trace(message); });
    };
    Analytics.sendEventData = function (data) {
        var _a;
        (_a = this.Instance) === null || _a === void 0 ? void 0 : _a.execute(function (provider) { return provider.eventData(data); });
    };
    // eslint-disable-next-line no-use-before-define
    Analytics.Instance = undefined;
    return Analytics;
}());
exports.default = Analytics;
